import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-language-plugin',
  templateUrl: './language-plugin.component.html',
  styleUrls: ['./language-plugin.component.scss']
})
export class LanguagePluginComponent implements OnInit {
  availableLanguages: Array<any> = [
    { code: 'en-US', icon: 'en-US.svg', isSelected: false},
    { code: 'es-ES', icon: 'es-ES.svg', isSelected: true},
  ];
  currentLanguage: any = {};

  constructor(
    private translate: TranslateService,
    private _commonService: CommonService
  ) {
    translate.setDefaultLang('es-ES');

  }

  ngOnInit(): void {
    this.currentLanguage = this.availableLanguages.find(language => language.isSelected);
   
  }

  changeLanguage(codeLang: string): void {
    let selectedLanguage = this.availableLanguages.find(lang => lang.code === codeLang);
    selectedLanguage.isSelected = true;
    this.currentLanguage = selectedLanguage;
    this.translate.use(selectedLanguage.code);
    
  }
}
